<template>
	<div class="data-content">
		<div class="top-box">
			<div>
				<button class="add-btn" @click="handleEditUser('add')" v-if="perms.includes('sys:user:add')">新增</button>
				<button class="import-btn" @click="handleImport('user')" v-if="perms.includes('sys:user:import')">导入</button>
				<input style="display: none" ref="uploadExcel" type="file" id="uploadExcel" @change="uploadHandle($event)" />
				<button class="import-btn" @click="handleExport" v-if="perms.includes('sys:user:export')">导出</button>
				<el-dropdown placement="bottom" @command="handleCommand" v-if="perms.includes('sys:user:import')">
					<el-button type="primary" size="small" class="template-btn">模板下载</el-button>
					<template #dropdown>
						<el-dropdown-menu>
							<el-dropdown-item command="default">用户模板</el-dropdown-item>
							<el-dropdown-item command="bind">成绩合并模板</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
				<button class="template-btn" @click="handleExportPotints" v-if="perms.includes('sys:user:export')">积分导出</button>
				<button class="template-bbs-btn" @click="handleExportBbsData" v-if="perms.includes('sys:user:export')">BBS互动导出</button>
				<button class="import-btn" @click="handleImport('merge')" v-if="perms.includes('sys:user:import')">成绩合并导入</button>
				<button class="import-btn" @click="handleUploadImage" v-if="perms.includes('sys:user:import')">用户照片更新</button>
			</div>
			<div class="top-right-box">
				<label class="label">关键字</label>
				<el-input class="search-input" size="small" type="text" v-model="searchKey" placeholder="请输入关键字"></el-input>
				<label class="label">角色名称</label>
				<el-input class="search-input" size="small" type="text" v-model="roleName" placeholder="请输入角色名称"></el-input>
				<label class="label">区域</label>
				<el-select class="search-input" size="small" v-model="area" filterable placeholder="请选择">
					<el-option value="" label="全部"></el-option>
					<el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<label class="label">有效性</label>
				<el-select class="search-input" size="small" v-model="active" filterable placeholder="请选择">
					<el-option value="" label="全部"></el-option>
					<el-option value="1" label="有效"></el-option>
					<el-option value="0" label="失效"></el-option>
				</el-select>
				<img class="search-btn" src="@/assets/images/sousuo.png" alt="" @click="getUserList" />
				<el-button icon="el-icon-refresh-right" class="refresh-btn" @click="handleReset"></el-button>
			</div>
		</div>
		<div class="data-list-box">
			<el-table :data="userList" :row-class-name="tableRowClassName" :header-cell-style="{ color: '#444' }" border style="width: 100%">
				<el-table-column label="NO." width="60">
					<template slot-scope="scope">
						<span class="no">{{ scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" show-overflow-tooltip label="姓名"></el-table-column>
				<el-table-column prop="code" show-overflow-tooltip label="用户ID"></el-table-column>
				<el-table-column prop="stuId" show-overflow-tooltip label="学员ID"></el-table-column>
				<el-table-column prop="email" label="邮箱"></el-table-column>
				<el-table-column prop="tel" label="手机号"></el-table-column>
				<el-table-column prop="roleNames" show-overflow-tooltip label="角色名称"></el-table-column>
				<el-table-column prop="areaName" show-overflow-tooltip label="区域"></el-table-column>
				<el-table-column label="状态" align="center" width="50">
					<template slot-scope="scope">
						<span v-if="scope.row.active == 1">Y</span>
						<span v-if="scope.row.active == 0" style="color: red">N</span>
					</template>
				</el-table-column>
				<el-table-column prop="agentName" show-overflow-tooltip label="公司名称"></el-table-column>
				<el-table-column label="操作" width="130">
					<template slot-scope="scope">
						<button class="btn-blue" @click="handleEditUser('check', scope.row)">查看</button>
						<template v-if="isUserCouldEdit(scope.row)">
							<button class="btn-blue" @click="handleEditUser('edit', scope.row)" v-if="perms.includes('sys:user:update')">编辑</button>
							<button class="btn-blue" @click="handleEditUserStatus(scope.row)" v-if="perms.includes('sys:user:active') && scope.row.active == 0">
								激活
							</button>
							<button class="btn-red" @click="handleEditUserStatus(scope.row)" v-if="perms.includes('sys:user:invalid') && scope.row.active == 1">
								失效
							</button>
							<button class="btn-red" @click="handleDeleteData(scope.row)" v-if="perms.includes('sys:user:delete') && scope.row.active == 0">
								删除
							</button>
							<button class="btn-blue" @click="handleResetPassword(scope.row)" v-if="perms.includes('sys:user:reset')">重置密码</button>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-wrapper pa25">
				<Pagination
					:page.sync="pageNo"
					:pageSize.sync="pageSize"
					:total="total"
					@sizeChange="handleSizeChange"
					@currentChange="handleCurrentChange"></Pagination>
			</div>
		</div>
		<edit-user ref="editUser" @getUserList="getUserList"></edit-user>
		<export-filter ref="exportFilter" @getUserList="getUserList"></export-filter>
		<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" class="role-dialog" width="450px">
			<span slot="title" class="dialog-title">
				<span>提示</span>
				<img src="@/assets/images/close.png" alt="" @click="visible = false" />
			</span>
			<ul class="error-list">
				<li v-for="(item, i) in errorList" :key="i">{{ item }}</li>
			</ul>
		</el-dialog>
		<upload-image ref="uploadImage" @getUserList="getUserList"></upload-image>
	</div>
</template>
<script>
import EditUser from "./components/edit-user";
import Pagination from "@/components/Pagination";
import exportFilter from "./components/exportFilter";
import UploadImage from "./components/upload-image";

export default {
	components: {
		EditUser,
		Pagination,
		exportFilter,
		UploadImage,
	},
	data() {
		return {
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			searchKey: "",
			roleName: "",
			active: "",
			area: "",
			roleList: [],
			areaList: [],
			pageNo: 1,
			pageSize: 10,
			total: 0,
			userList: [],
			visible: false,
			errorList: [],
			uploadUrl: "",
		};
	},
	created() {
		// 获取区域数据
		this.getAreaList();
		this.getRoleList();
		this.getUserList();
	},
	methods: {
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		// 重置查询条件
		handleReset() {
			this.searchKey = "";
			this.roleName = "";
			this.active = "";
			this.area = "";
			this.pageNo = 1;
			this.getUserList();
		},
		// 新增/编辑/查看角色
		handleEditUser(type, data) {
			this.$refs.editUser.init(type, data);
		},
		// 获取角色类型
		getRoleList() {
			let that = this;
			that.$request.get(
				"sysRoleList",
				true,
				{
					name: "",
					type: "",
					pageNo: 1,
					pageSize: 999,
				},
				function (r) {
					if (r.code == "0") {
						that.roleList = r.data.list;
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		getAreaList() {
			let that = this;
			that.$request.post(
				"sysDataDetailPageList",
				false,
				{
					pageNo: 1,
					pageSize: 999,
					code: "areaType",
				},
				function (r) {
					if (r.code == "0") {
						that.areaList = r.data.list;
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		handleSizeChange() {
			this.getUserList();
		},
		handleCurrentChange() {
			this.getUserList();
		},
		handleSearch() {
			this.pageNo = 1;
			this.getUserList();
		},
		// 获取用户列表数据
		getUserList() {
			let that = this;
			that.$request.get(
				"sysUserList",
				true,
				{
					searchKey: that.searchKey,
					roleName: that.roleName,
					areaId: that.area,
					active: that.active,
					pageNo: that.pageNo,
					pageSize: that.pageSize,
				},
				function (r) {
					if (r.code == "0") {
						that.userList = r.data.list;
						that.total = r.data.totalCount;
					} else {
						that.$message.error(r.msg);
					}
				},
			);
		},
		// 更改用户状态
		handleEditUserStatus(dt) {
			let tips = dt.active == 1 ? "是否失效当前用户?" : "是否激活当前用户?";
			let statusUrl = dt.active == 1 ? "sysUserInvalid" : "sysUserActive";
			this.$confirm(tips, {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let that = this;
					that.$request.post(
						statusUrl,
						true,
						{
							id: dt.id,
						},
						function (r) {
							if (r.code == "0") {
								that.getUserList();
								that.$message.success("用户状态已变更");
							} else {
								that.$message.error(r.msg);
							}
						},
					);
				})
				.catch(() => {});
		},
		// 删除
		handleDeleteData(data) {
			this.$confirm("是否删除当前用户?", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let that = this;
					that.$request.post(
						"sysUserDelete",
						true,
						{
							id: data.id,
						},
						function (r) {
							if (r.code == "0") {
								that.getUserList();
								that.$message.success("删除成功");
							} else {
								that.$message.error(r.msg);
							}
						},
					);
				})
				.catch(() => {});
		},
		// 重置密码
		handleResetPassword(data) {
			this.$confirm("是否重置当前用户密码?", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let that = this;
					that.$request.post(
						"sysUserResetPassword",
						true,
						{
							id: data.id,
						},
						function (r) {
							if (r.code == "0") {
								that.$message.success("重置密码成功");
							} else {
								that.$message.error(r.msg);
							}
						},
					);
				})
				.catch(() => {});
		},
		// 导入
		handleImport(type) {
			let el = document.getElementById("uploadExcel");
			el.click();
			let obj = {
				user: "sysUserUpload",
				merge: "mergeDataUpload",
			};
			this.uploadUrl = obj[type];
		},
		// 上传
		uploadHandle(e) {
			let file = e.target.files[0];
			if (file) {
				if (window.sessionStorage.getItem("userInfo").superAdminFlag == "1" && file.size / 1024 / 1024 / 1024 > 1) {
					this.$message.error("导入文件不能大于1GB");
					return;
				}
				// 2022-07-31 应客户要求改为200M
				if (window.sessionStorage.getItem("userInfo").superAdminFlag != "1" && file.size / 1024 / 1024 > 200) {
					this.$message.error("导入文件不能大于200MB");
					return;
				}
				if (file.name.includes(".xlsx")) {
					let formdata = new FormData();
					formdata.append("file", file);
					let that = this;
					that.$request.initUploadExcel(formdata, that.uploadUrl, true).then((data) => {
						if (data.code == 0) {
							that.pageNo = 1;
							that.getUserList();
							if (data.data.length > 0) {
								that.visible = true;
								that.errorList = data.data;
							} else {
								that.$message.success("导入成功");
							}
						}
					});
				} else {
					this.$message.error("文件格式不正确");
				}
			} else {
				this.$message.error("请选择上传的文件");
			}
			this.$refs.uploadExcel.value = "";
		},
		// 导出
		handleExport() {
			let that = this;
			that.$request.get(
				"sysUserDownload",
				true,
				{
					searchKey: that.searchKey,
					roleName: that.roleName,
					areaId: that.area,
					active: that.active,
				},
				function (res) {
					if (res.code == "0") {
						const linkNode = document.createElement("a");
						linkNode.style.display = "none";
						linkNode.href = res.data;
						document.body.appendChild(linkNode);
						linkNode.click(); //模拟在按钮上的一次鼠标单击
						URL.revokeObjectURL(linkNode.href); // 释放URL 对象
						document.body.removeChild(linkNode);
					} else {
						that.$message.error(res.msg);
					}
				},
			);
		},
		// 用户是否可编辑
		isUserCouldEdit(user) {
			return !(user.isEdit === "2" || user.isEdit === 2);
		},
		// 导出积分
		handleExportPotints() {
			let that = this;
			let data = {
				searchKey: that.searchKey,
				roleName: that.roleName,
				areaId: that.area,
				active: that.active,
			};
			this.$refs.exportFilter.show("potins", data);
		},
		// 导出BBS参与情况
		handleExportBbsData() {
			let that = this;
			let data = {
				searchKey: that.searchKey,
				roleName: that.roleName,
				areaId: that.area,
				active: that.active,
			};
			this.$refs.exportFilter.show("bbs", data);
		},
		// 模板下载
		handleCommand(value) {
			// 经销商导入模板
			if (value === "default") {
				let downloadHref = "/static/template/USER-DATA.xlsx";
				let downloadName = "USER-DATA.xlsx";
				this.handleTemplate(downloadHref, downloadName);
			}
			// 经销商归属关系绑定模板
			if (value === "bind") {
				let downloadHref = "/static/template/MERGE-RESULT-DATA.xlsx";
				let downloadName = "MERGE-RESULT-DATA.xlsx";
				this.handleTemplate(downloadHref, downloadName);
			}
		},
		// 模板下载
		handleTemplate(downloadHref, downloadName) {
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = downloadHref;
			linkNode.download = downloadName;
			document.body.appendChild(linkNode);
			linkNode.click(); //模拟在按钮上的一次鼠标单击
			URL.revokeObjectURL(linkNode.href); // 释放URL 对象
			document.body.removeChild(linkNode);
		},
		// 用户照片更新
		handleUploadImage() {
			this.$refs.uploadImage.init();
		},
	},
};
</script>
<style lang="scss" scoped>
.block {
	display: block;
}
.data-content {
	.top-box {
		// height: 32px;
		margin-bottom: 20px;
	}
	.add-btn {
		display: inline-block;
		padding: 0 18px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: #117ffc;
		border-radius: 4px;
		color: #fff;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}
	.import-btn {
		display: inline-block;
		padding: 0 18px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: rgba(17, 127, 252, 0.2);
		border-radius: 4px;
		color: #117ffc;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}
	.template-btn {
		display: inline-block;
		width: 88px;
		height: 32px;
		border: none;
		background-color: rgba(17, 127, 252, 0.2);
		border-radius: 4px;
		color: #117ffc;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}
	.template-bbs-btn {
		display: inline-block;
		width: 110px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: rgba(17, 127, 252, 0.2);
		border-radius: 4px;
		color: #117ffc;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}
	.top-right-box {
		// float: right;
		text-align: right;
		margin-top: 15px;
		.label {
			font-size: 15px;
			margin-right: 5px;
		}
		.search-input {
			width: 138px;
			margin: 0 10px;
		}
		.search-btn {
			width: 32px;
			vertical-align: middle;
			cursor: pointer;
		}
		.refresh-btn {
			width: 32px;
			height: 32px;
			border: none;
			color: #117ffc;
			padding: 0;
			background-color: rgba(17, 127, 252, 0.2);
			font-weight: bold;
			font-size: 22px;
			vertical-align: bottom;
			margin-left: 5px;
		}
	}
	.btn-blue {
		font-size: 12px;
		font-weight: bold;
		color: #1081fd;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background-color: #fff;
		margin-right: 10px;
	}
	.btn-red {
		font-size: 12px;
		font-weight: bold;
		color: #e9515e;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background-color: #fff;
		margin-right: 10px;
	}
}
.dialog-title {
	display: block;
	text-align: center;
	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}
	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}
.error-list {
	height: 50vh;
	box-sizing: border-box;
	padding: 20px;
	overflow: auto;
	li {
		list-style: none;
	}
}
</style>
<style>
.el-message .user-message {
	margin: 15px;
}
</style>
